export default __webpack_public_path__ + "static/media/marr2.57ebee6c.jpeg";